import { REDUCER_KEY } from "./auth.constants";
export var getUser = function (state) { return state[REDUCER_KEY].user; };
export var updateUserById = function (id, state) {
    return state[REDUCER_KEY].updateUserById[id];
};
export var hasAccessToken = function (state) { var _a; return ((_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.hasAccessToken) || false; };
export var getSelectedDashboardType = function (state) {
    return state[REDUCER_KEY].selectedDashboardType;
};
export var isRemovingProfile = function (state) {
    return state[REDUCER_KEY].isRemovingProfile;
};
export var removeProfileError = function (state) {
    return state[REDUCER_KEY].removeProfileError;
};
export var shouldRefetch = function (state) {
    return state[REDUCER_KEY].refetch;
};
